import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faThumbtack, faTrash } from '@fortawesome/pro-solid-svg-icons';

import {
  pinListing,
  unpinListing,
} from './actions';

export class ListingRow extends Component {
  renderLoadingCTA = () => <FontAwesomeIcon icon={faSpinner} name="listing-loading" spin/>;

  renderTrashCTA = () => {
    return (
      <FontAwesomeIcon
        className="clickable text-danger"
        icon={faTrash}
        name="unpin-listing"
        onClick={() => this.props.unpinListing(this.props.listing)}
      />
    );
  }

  renderPinCTA() {
    return (
      <FontAwesomeIcon
        className="clickable"
        icon={faThumbtack}
        name="pin-listing"
        onClick={() => this.props.pinListing(this.props.listing)}
      />
    );
  }

  renderCta() {
    const { listing, updatingListingId, pinned, clearing } = this.props;

    if ((pinned && clearing) || updatingListingId == listing.id) return this.renderLoadingCTA();
    return pinned ? this.renderTrashCTA() : this.renderPinCTA();
  }
  render() {
    const { listing, dragSource } = this.props;

    return (
      <div className="align-items-center border-bottom d-flex mx-0 p-3" key={listing.id} name="search-result">
        {dragSource}
        <div>
          <div>
            {listing.displayName || listing.name}
          </div>
          <div className="text-muted">
            {listing.broker}
          </div>
        </div>
        <span className="flex-grow-1 text-end">
          {this.renderCta()}
        </span>
      </div>
    );
  }
}

ListingRow.propTypes = {
  clearing: PropTypes.bool,
  dragSource: PropTypes.node,
  listing: PropTypes.shape({
    displayName: PropTypes.string,
    name: PropTypes.string
  }),
  pinListing: PropTypes.func.isRequired,
  pinned: PropTypes.bool,
  unpinListing: PropTypes.func.isRequired,
  updatingListingId: PropTypes.number
};
const mapStateToProps = ({ module }) => ({
  clearing: module.clearing,
  updatingListingId: module.updatingListingId
});
const mapDispatchToProps = {
  pinListing,
  unpinListing,
};

export default connect(mapStateToProps, mapDispatchToProps)(ListingRow);
